import React from "react";
import { Card, Button, Popconfirm } from "antd";
import { DateTime } from "luxon";

export default function Note({ item, onEdit, onDelete }) {
  const title = item.isCommon
    ? "Основная заметка"
    : DateTime.fromISO(item.createdAt).toLocaleString();

  return (
    <li key={`note-${item.id}`} style={{ marginTop: "5px" }}>
      <Card
        title={title}
        bordered={true}
        extra={
          <div>
            <Button
              type="primary"
              ghost
              shape="round"
              icon="edit"
              onClick={() => onEdit(item)}
              style={{ marginRight: 5 }}
            ></Button>
            <Popconfirm title="Delete note?" onConfirm={() => onDelete(item)}>
              <Button
                danger
                type="primary"
                ghost
                shape="round"
                icon="delete"
              ></Button>
            </Popconfirm>
          </div>
        }
      >
        <span dangerouslySetInnerHTML={{ __html: item.content }} />
      </Card>
    </li>
  );
}
